<div class="mat-elevation-z4 data-table">
    <div *ngFor="let _ of numberOfDivs; let i = index" class="table-cell">
        <div class="bone table-cell-content"></div>
    </div>
</div>
